import http from 'hub-http/clients/apiClient';
// @ts-expect-error untyped
import { TaskQueueManager as TaskQueueManagerClass } from 'task-queues/TaskQueueManager';
import { StorageWrapper } from 'task-queues/storage/StorageWrapper';
const storage = new StorageWrapper(sessionStorage);

// Configure the task queue lib for this app
export const TaskQueueManager = new TaskQueueManagerClass(http, storage);